import { Flex, LoadingIndicator, Typography } from '@aloft/toolkit-sui';

import { ContentfulDocument } from '../../../../components/ContentfulDocument/ContentfulDocument.js';
import { useSidebarUpdates } from '../../hooks/useSidebarUpdates.js';
import { Update } from './Update.js';
import { useAppSelector } from '../../../../redux/hooks.js';
import { selectUserType } from '../../../../redux/features/selectors/accountSelectors.js';

export const ContentfulUpdatesList = () => {
  const { updates = [], isLoading, isError } = useSidebarUpdates();
  const userType = useAppSelector(selectUserType);

  const filteredUpdates = updates.filter((update) => {
    if (userType === 'saas') {
      return update.fields.showForSaaSUsers;
    }
    if (userType === 'appraisify') {
      return update.fields.showForInternalUsers;
    }
    return true; // Show all updates if userType is not defined
  });

  if (isLoading) {
    return <LoadingIndicator message="Loading updates..." />;
  }

  if (isError) {
    return (
      <Typography>
        We&apos;re sorry, there was an error getting the latest updates. Please check back later.
      </Typography>
    );
  }

  return (
    <Flex flexDirection="column" gap=".75rem">
      {filteredUpdates.map((update) => (
        <Update key={update.sys.id} title={update.fields.title}>
          <ContentfulDocument document={update.fields.content} />
        </Update>
      ))}
      {filteredUpdates.length === 0 && (
        <Typography>No updates available at this time. Please check back later.</Typography>
      )}
    </Flex>
  );
}
